import React, { Component } from "react";
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { NotificationContainer } from 'react-notifications';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";

import Logout from "./../../../loginService/logout";
import FundsTableMgm from "./funds_table";
import BudgetPlanMgm from "./budget_table";
import NewPlanPopUp from "./new_budget_plan";

const backend = require('../../../config.js').backend;

const StartDateInput = React.forwardRef(({ value, onClick }, ref) => (
  <input
    data-testid="start-date-input"
    onClick={onClick}
    ref={ref}
    value={value}
  />
));

const EndDateInput = React.forwardRef(({ value, onClick }, ref) => (
  <input
    data-testid="end-date-input"
    onClick={onClick}
    ref={ref}
    value={value}
  />
));

class Funds_Budget_Plan_Mgm extends Component {

    constructor(props) {

        super(props);

        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            plans: [],
            errors: {},
            showPlanPopup: false,
            staffid: sessionStorage.getItem('id_e'),
            bankAccounts: {},
            bankAccountsDropDown: [],
            loading: true,
            redirectLogout: false
        }

        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);

        this.togglePlanPopup = this.togglePlanPopup.bind(this);
        this.handleAction = this.handleAction.bind(this);

    }


    componentDidMount() {

        this.getPlanWithAccOverAPeriod(this.state.startDate, this.state.endDate)
            .then((plans) => {
                this.setState({ plans: plans });
            })

        this.getAllBankAccount()
            .then((bankAcc) => {

                // console.log(bankAcc)
                this.setState({ bankAccounts: bankAcc.object });
                this.setState({ bankAccountsDropDown: bankAcc.list }, () => {
                    this.setState({ loading: false })
                });
            })

    }


    getAllBankAccount = _ => {
        var accountList = [];
        var accountObject = {}
        var that = this;

        return new Promise(function (resolve, reject) {

            var url = `api/v1/bankacc`;
            fetch(backend + url, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    // console.log(data);
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else {
                        data.forEach(function (item, index) {
                            // console.log(item, index);
                            accountList.push({
                                'value': item.BankAccID,
                                'label': item.BankAccName
                            })
                            accountObject[item.BankAccID] = item.BankAccName;

                        });

                        accountList.sort((a, b) => (a.label > b.label) ? 1 : -1);

                        resolve({ list: accountList, object: accountObject });
                        // resolve (data)
                    }
                })
                .catch((err) => {
                    console.log('getAllBankAccount error', err);
                    reject(err)
                })

        })

    }


    handleStartDateChange(date) {

        date = moment(date).format('YYYY-MM-DD');

        this.setState({
            startDate: date
        });

    }

    handleEndDateChange(date) {

        date = moment(date).format('YYYY-MM-DD');

        this.setState({
            endDate: date
        });

    }

    togglePlanPopup = _ => {
        console.log('togglePlanPopup');
        this.setState({ showNewPlanPopup: !this.state.showNewPlanPopup });
    }

    handleAction = _ => {
        this.togglePlanPopup();
    }


    inputValid = () => {

        let { startDate } = this.state;
        let { endDate } = this.state;
        let today = new Date()
        let errors = {};

        if (startDate > endDate || startDate > today) {

            errors['date'] = 'Please choose correct dates!'; this.setState({ errors: errors });
            return false;

        }
        else {
            errors = {};
            this.setState({ errors: errors });
            return true;

        }

    }

    datePicker = () => {

        return (
            <div className="form-set row">
                <form className="form-horizontal">
                    <div className="form-sets col-sm-12">
                        <fieldset>
                            <div className="fieldset">

                                <div className='input-dates col-sm-10'>

                                    <div className="col-sm-4 input-startdate">
                                        <label className="col-lg-4 control-lebel"> START DATE</label>
                                        <div className='datepicker'>
                                            <DatePicker
                                                selected={(this.state.startDate === '') ? new Date() : new Date(this.state.startDate)}
                                                onChange={this.handleStartDateChange}
                                                dateFormat='dd-MM-yyyy'
                                                showMonthDropdown
                                                showYearDropdown
                                                scrollableMonthYearDropdown
                                                customInput={<StartDateInput/>}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-sm-4 input-enddate">
                                        <div className='float-right'>
                                            <label className="col-lg-4 control-lebel"> END DATE</label>
                                            <div className='datepicker datepicker-right'>
                                                <DatePicker
                                                    selected={(this.state.endDate === '') ? new Date() : new Date(this.state.endDate)}
                                                    onChange={this.handleEndDateChange}
                                                    dateFormat='dd-MM-yyyy'
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    scrollableMonthYearDropdown
                                                    customInput={<EndDateInput/>}
                                                />
                                            </div>
                                            <span className="error">{this.state.errors["date"]}</span>
                                        </div>
                                    </div>

                                </div>

                                <div className="col-sm-2 check-button">
                                    <button type="button" className="btn btn-primary submit" disabled={this.state.isButtonDisabled} onClick={this.getPlans}>CHECK</button>
                                </div>

                            </div>
                        </fieldset>
                    </div>
                </form>
            </div>
        )
    }


    getPlans = _ => {

        let { startDate } = this.state;
        let { endDate } = this.state;
        this.setState({ plans: {} });


        if (this.inputValid()) {

            this.setState({ checked: true })

            this.getPlanWithAccOverAPeriod(startDate, endDate)
                .then((plans) => {
                    this.setState({ plans: plans });
                })

        }

    }


    getPlanWithAccOverAPeriod = (startDate, endDate) => {

        endDate = moment(endDate).format('YYYY-MM-DD');
        startDate = moment(startDate).format('YYYY-MM-DD');
        const { staffid } = this.state;
        // startDate = '2020-07-01'
        // endDate = '2020-07-31'
        var that = this;

        return new Promise(function (resolve, reject) {

            var url = `api/v1/budgetplanwithacc/` + staffid + `?start=` + startDate + `&end=` + endDate;

            fetch(backend + url, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    //   console.log(data);
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    } else {
                        resolve(data);
                    }
                })
                .catch((err) => {
                    console.log('getPlanWithAccOverAPeriod error', err);
                    reject(err)
                })

        })
    }


    renderPlanTable = (table) => {

        var fundAccounts = table.FundAccounts;
        // console.log('bankAccounts', this.state.bankAccounts)
        // console.log('bankAccountsDropDown', this.state.bankAccountsDropDown)

        return (
            <div key={table.PlanID}>

                <div className='budget-plan-details' key={table.PlanID}>

                    <BudgetPlanMgm
                        table={table}
                        refresh={this.getPlans}
                        bankAccounts={this.state.bankAccounts}
                        bankAccountsDropDown={this.state.bankAccountsDropDown}
                    />

                    <FundsTableMgm
                        fundAccounts={fundAccounts}
                        planId={table.PlanID}
                        refresh={this.getPlans}
                        bankAccounts={this.state.bankAccounts}
                        bankAccountsDropDown={this.state.bankAccountsDropDown}
                    />

                </div>

            </div>

        )

    }

    renderTables = _ => {

        const { plans } = this.state;

        if (plans.length) {
            return (
                plans.map(this.renderPlanTable)
            )
        }
        else {
            return (
                <h5>No Fund-raising Projects found</h5>
            )
        }


    }


    render() {

        const { redirectLogout } = this.state;
        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        if (this.state.loading) {
            return <div> <h2>Loading...</h2> </div>
        }

        else {

            let plans_in_tables = this.renderTables();
            let date_picker = this.datePicker();

            let content = (
                <div className='budget-plan-mgm'>
                    <h3>Fund-raising Projects</h3>

                    <div>
                        <div className='new-budget-plan'>
                            <div className='new-budget-plan-button'>
                                <AddCircleIcon onClick={this.handleAction} />
                                <label>Add a new project</label>
                            </div>
                        </div>
                    </div>

                    <div className='check-budget-plan'>
                        <h5>Check Projects By Dates:</h5>
                        {date_picker}
                    </div>

                    <div className='budget-plan-list'>
                        {plans_in_tables}
                    </div>

                    {(this.state.showNewPlanPopup) ?
                        <NewPlanPopUp
                            togglePopup={this.togglePlanPopup.bind(this)}
                            refresh={this.getPlans}
                        />
                        : null
                    }
                    <NotificationContainer />

                </div>
            )


            return (content);

        }



    }

}

export default Funds_Budget_Plan_Mgm;